import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { trashKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useRestoreBrands() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (brandIds: number): Promise<void> => {
      apiClient.url(`/brands/restore/${brandIds}`).post();
    },
    onError: (error: Error) => {
      toast.add({
        description: error.message || "Failed to restore brands",
        timeout: 3000,
        type: "error",
      });
    },
    onSuccess: () => {
      toast.add({
        description: "Brand restored successfully",
        timeout: 3000,
        type: "success",
      });
      queryClient.invalidateQueries({ queryKey: trashKeys.all });
    },
  });
}
